export default "__VITE_ASSET__CnC8CLdI__"